import { Loader2 } from 'lucide-react';
import React from 'react';

export const Loader = ({ children }: { children?: React.ReactNode }) => {
  return (
    <div className="flex items-center justify-center h-screen">
      <Loader2 className="animate-spin" />
      {children}
    </div>
  );
};
